<template>
    <div>
        <Header @show-contact="showContact" :active="2" :title="'解决方案'"></Header>
        <!-- 导航栏 -->
        <div class="banner">
            <img class="banner_pc" src="../../assets/image/banner/banner_lowAltitude.jpg"></img>
            <img class="banner_m" src="../../assets/image/banner/banner_lowAltitude_m.jpg"></img>
        </div>
        <!-- 教育培训 -->
        <div class="lowAltitude">
            <div class="content-e">
                <div class="left">
                    <span>eVTOL 飞行训练与飞行体验</span>
                    <img src="../../assets/image/solution/lowAltitude1.jpg">
                    <div class="text">
                        <p>亮点</p>
                        <p>
                            <br>6DOF全域追踪和随动<br><br>
                            极端场景随时复现<br><br>
                            缩短训练周期、降低危险与成本<br><br>
                            真实沉浸感飞行体验<br>
                        </p>
                    </div>
                </div>
                <div class="left">
                    <span>eVTOL AR航道展示</span>
                    <img src="../../assets/image/solution/lowAltitude2.jpg">
                    <div class="text">
                        <p>亮点</p>
                        <p>
                            <br>6DOF+SLAM定位<br><br>
                            增强现实显示航道展示<br><br>
                            偏航及碰撞提示<br><br>
                            飞行员驾驶训练辅助决策<br>
                        </p>
                    </div>
                </div>
                <div class="left">
                    <span>eVTOL 远程操控</span>
                    <img src="../../assets/image/solution/lowAltitude3.jpg">
                    <div class="text">
                        <p>亮点</p>
                        <p>
                            <br>第一视角远程操控、沉浸式体验<br><br>
                            虚实融合操作复杂面板<br><br>
                            高效的数据处理<br><br>
                            固态视场与动态视场结合<br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>

<script>
import Footer from '../../components/Footer.vue'
import Header from '../../components/Head.vue'
import Contact from '../../components/Contact.vue'
import Email from '../../components/Email.vue'
export default {
    data() {
        return {
            isContactVisible: false
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    methods: {
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        }
    },
}
</script>
<style scoped>
@import '../../assets/css/solution/lowAltitude.css';
</style>